export const updateChangedUsers = (users, values) => {
  return users?.map(user => {
    if (user.goal.id === values.id) return {...user, goal: values};
    return {...user, users: updateChangedUsers(user.users, values)};
  });
};